import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'

// `children` lets a caller append extra options inside the same group.
// `id` is the control-id prefix; each checkbox is `${id}-${index}`.
const MultiChoiceField = ({ field, id: idPrefix = field.id, value, onChange, disabled, children }) => {
  const selected = Array.isArray(value) ? value : []

  const toggle = (choice) => {
    onChange(
      selected.includes(choice)
        ? selected.filter((v) => v !== choice)
        : [...selected, choice]
    )
  }

  return (
    <div className="flex flex-wrap gap-4">
      {field.choices.map((choice, index) => {
        const id = `${idPrefix}-${index}`
        return (
          <div key={choice} className="flex items-center gap-2">
            <Checkbox
              id={id}
              checked={selected.includes(choice)}
              onCheckedChange={() => toggle(choice)}
              disabled={disabled}
              className="h-5 w-5 border-2"
            />
            <Label htmlFor={id} className="text-sm font-normal cursor-pointer">{choice}</Label>
          </div>
        )
      })}
      {children}
    </div>
  )
}

export default MultiChoiceField
